import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import styled from 'styled-components';
import { Draggable, DragComponent, Droppable } from 'react-dragtastic';
import { Loader } from 'react-loaders';
import { getRequest, postRequest } from '../../../api/ApiService';

import EqualIcon from '../../../containers/assets/onboarding-equal.png';
import GripIcon from '../../../containers/assets/onboarding-grip.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Formula = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 45px;
`;

const Formula1 = styled.div`
  width: 150px;
  height: 82px;
  background: rgba(0, 27, 59, 0.04);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #5c91f5;
`;

const Formula2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
`;

const Formula3 = styled.div`
  width: 200px;
  height: 68px;
  background: #ffffff;
  border-radius: 8px;
  border: 1.5px dashed rgba(0, 27, 59, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;

  ${p => p.isDropped && `
    background: rgba(0, 27, 59, 0.08);
  `}
`;

const Formula4 = styled.div`
  width: 200px;
  height: 1px;
  background: rgba(0, 27, 59, 0.94);
`;

const Options = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 16px;
`;

const Option = styled.div`
  display: block;
  padding: 12px 20px 12px 24px;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 8px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 6px 4px rgba(0, 0, 0, 0.08);

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.94);
  cursor: pointer;
  position: relative;

  ${p => p.isHidden && `
    opacity: 0;
  `}

  ${p => p.isDropped && `
    box-shadow: none;
    display: inline-block;
    cursor: default;
  `}

  img {
    position: absolute;
    top: 10px;
    left: 4px;
  }
`;

class TriviaFormula2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      top: null,
      bottom: null,
      isReadOnly: false,
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { data } = this.props;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('disabled');

    this.props.setFetchData(true);
    getRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .then(res => {
        const answer = res.body.results.find(i => (
          i.user === userId
          && i.trivia_question === questionId
          && i.course_trivia === triviaId
        ));
        const isReadOnly = !!answer;
        const topChoice = answer ? answer.pickedoptions.find(i => i.order === 1) : null;
        const top = topChoice ? topChoice.option_choice : null;
        const bottomChoice = answer ? answer.pickedoptions.find(i => i.order === 2) : null;
        const bottom = bottomChoice ? bottomChoice.option_choice : null;

        if (isReadOnly) {
          this.props.setMode('basic');
        }

        this.props.setFetchData(false);
        this.setState({
          isReadOnly,
          top,
          bottom,
        });
      })
      .catch(err => {});
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.num !== prevProps.data.num) {
      this.setState({
        top: null,
        bottom: null,
        isReadOnly: false,
      }, () => {
        this.fetchData();
      });
    }
  }

  onDropTop = val => {
    this.setState({
      top: val,
    }, () => {
      this.prevalidate();
    });
  }

  onDropTopOut = () => {
    this.setState({
      top: null,
    }, () => {
      this.prevalidate();
    });
  }

  onDropBottom = val => {
    this.setState({
      bottom: val,
    }, () => {
      this.prevalidate();
    });
  }

  onDropBottomOut = () => {
    this.setState({
      bottom: null,
    }, () => {
      this.prevalidate();
    });
  }

  prevalidate = () => {
    const { top, bottom } = this.state;

    if (!!top && !!bottom) {
      this.props.setMode('validate', this.validate);
    } else {
      this.props.setMode('disabled');
    }
  }

  validate = () => {
    const { data } = this.props;
    const { top, bottom } = this.state;
    const { userId, questionId, triviaId } = data;

    this.props.setMode('loading');
    postRequest(`${process.env.REACT_APP_API_URL}v2/trivia/triviaresponses/`)
      .send({
        user: userId,
        trivia_question: questionId,
        course_trivia: triviaId,
        pickedoptions: [
          { option_choice: top, order: 1 },
          { option_choice: bottom, order: 2 },
        ],
      })
      .then(res => {
        if (res.body.is_correct === 'Yes') {
          this.props.showConfetti();
        } else {
          this.props.showIncorrectMessage();
        }

        this.setState({
          isReadOnly: true,
        });

        this.props.setMode('basic');
      })
      .catch(err => {
        this.props.setMode('basic');
      });
  }

  render() {
    const { top, bottom, isReadOnly } = this.state;
    const { data, stage, isFetchData } = this.props;
    const { num, text, choices, caption } = data;
    let topText = null;
    if (top) {
      const topObj = choices.find(i => i.id === top);
      topText = topObj ? topObj.text : null;
    }

    let bottomText = null;
    if (bottom) {
      const bottomObj = choices.find(i => i.id === bottom);
      bottomText = bottomObj ? bottomObj.text : null;
    }

    return isFetchData ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Text1>Trivia: {stage === 'welcome' ? 'Warm Up' : `Round ${stage}`}</Text1>
        <Text2>{num}. {text}</Text2>
        <Formula>
          <Formula1>{caption}</Formula1>
          <img src={EqualIcon} alt="" />
          <Formula2>
            <Droppable
              id="formula1"
              accepts="formula"
              onDrop={this.onDropTop}
              onDragLeave={this.onDropTopOut}
            >
              {({ events, isOver }) => (
                <Formula3
                  {...events}
                  isDropped={isOver || !!top}
                >
                  {top && isReadOnly && (
                    <Option isDropped={true}>
                      <img src={GripIcon} alt="" />
                      {topText}
                    </Option>
                  )}
                  {top && !isReadOnly && (
                    <Draggable
                      id={`choice-${top}`}
                      type="formula"
                      data={top}
                    >
                      {({ isActive, events }) => (
                        <Option {...events} isDropped={true} isHidden={isActive}>
                          <img src={GripIcon} alt="" />
                          {topText}
                        </Option>
                      )}
                    </Draggable>
                  )}
                </Formula3>
              )}
            </Droppable>
            <Formula4 />
            <Droppable
              id="formula2"
              accepts="formula"
              onDrop={this.onDropBottom}
              onDragLeave={this.onDropBottomOut}
            >
              {({ events, isOver }) => (
                <Formula3
                  {...events}
                  isDropped={isOver || !!bottom}
                >
                  {bottom && isReadOnly && (
                    <Option isDropped={true}>
                      <img src={GripIcon} alt="" />
                      {bottomText}
                    </Option>
                  )}
                  {bottom && !isReadOnly && (
                    <Draggable
                      id={`choice-${bottom}`}
                      type="formula"
                      data={bottom}
                    >
                      {({ isActive, events }) => (
                        <Option {...events} isDropped={true} isHidden={isActive}>
                          <img src={GripIcon} alt="" />
                          {bottomText}
                        </Option>
                      )}
                    </Draggable>
                  )}
                </Formula3>
              )}
            </Droppable>
          </Formula2>
        </Formula>
        {!isReadOnly && (
          <Options>
            {choices.map(choice => (
              <Fragment key={`choice-fragment-${choice.id}`}>
                <Draggable
                  id={`choice-${choice.id}`}
                  type="formula"
                  data={choice.id}
                >
                  {({ isActive, events }) => (
                    <Option {...events} isHidden={isActive || top === choice.id || bottom === choice.id}>
                      <img src={GripIcon} alt="" />
                      {choice.text}
                    </Option>
                  )}
                </Draggable>
                <DragComponent for={`choice-${choice.id}`}>
                  {({ x, y }) => (
                    <Option style={{
                      position: 'fixed',
                      left: x - 20,
                      top: y - 21,
                      pointerEvents: 'none',
                      zIndex: 2,
                    }}>
                      <img src={GripIcon} alt="" />
                      {choice.text}
                    </Option>
                  )}
                </DragComponent>
              </Fragment>
            ))}
          </Options>
        )}
      </Wrapper>
    );
  }

}

export default TriviaFormula2;



// WEBPACK FOOTER //
// ./src/components/onboarding/trivia/Formula2.js